import React, { useState, useEffect } from "react";
import { FaGoogle, FaFacebook, FaLinkedin } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../AuthContext';
import KruozAPI from '../../KruozAPI';

const CustomerLogin = () => {
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate('/customer-home');
    }
  }, [user, navigate]);


  const handleSocialLogin = (provider) => {
    // Implement social login logic here
    console.log(`Logging in with ${provider}`);
  };

  const handleSendCode = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const encodedEmail = encodeURIComponent(email);
      const timeZone = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone);
      debugger;
      const response = await KruozAPI.post(
        `Users/SendVerificationCode?email=${encodedEmail}&role=Customer&timeZone=${timeZone}`
      );

      if (response.status === 200) {
        setIsCodeSent(true);
        // You might want to show a success message here
      } else {
        throw new Error("Failed to send verification code");
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Failed to send verification code. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
  
    try {
      const encodedEmail = encodeURIComponent(email);
      
      const verifyResponse = await KruozAPI.get(`Users/VerifyCode?email=${encodedEmail}&code=${verificationCode}&role=Customer`);
  
      if (verifyResponse.status === 200) {
        const userData = verifyResponse.data;
        
        // Call the token endpoint
        const tokenResponse = await KruozAPI.get(`Users/token?userId=${userData.id}&companyId=${userData.companyId}`);
        
        if (tokenResponse.status === 200) {
          // Update the user object with the received token
          userData.token = tokenResponse.data;
          
          // Use the login function from AuthContext
          login(userData);
          
          // Navigation will be handled by the useEffect hook
        } else {
          throw new Error('Failed to get token');
        }
      } else {
        throw new Error('Failed to verify code');
      }
    } catch (error) {
      console.error('Error details:', error);
      let errorMessage = 'Failed to verify code. Please try again.';
      if (error.response && error.response.data) {
        errorMessage = typeof error.response.data === 'string' 
          ? error.response.data 
          : JSON.stringify(error.response.data);
      } else if (error.message) {
        errorMessage = error.message;
      }
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-xl">
      <h2 className="text-3xl font-bold mb-6 text-center text-green-600">
        Customer Login
      </h2>
      {/* <div className="space-y-4 mb-6">
        <button
          onClick={() => handleSocialLogin("Google")}
          className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          <FaGoogle className="h-5 w-5 mr-2 text-red-500" />
          Login with Google
        </button>
        <button
          onClick={() => handleSocialLogin("Facebook")}
          className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          <FaFacebook className="h-5 w-5 mr-2 text-blue-600" />
          Login with Facebook
        </button>
        <button
          onClick={() => handleSocialLogin("LinkedIn")}
          className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          <FaLinkedin className="h-5 w-5 mr-2 text-blue-700" />
          Login with LinkedIn
        </button>
      </div> */}
      <div className="mt-6 text-center">
        <p className="text-sm text-gray-600 mb-4">Login with your email</p>
        {!isCodeSent ? (
          <form onSubmit={handleSendCode}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
              required
            />
            <button
              type="submit"
              className="mt-3 w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition-colors disabled:bg-green-300"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send Verification Code"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerifyCode}>
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              placeholder="Enter verification code"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
              required
            />
            <button
              type="submit"
              className="mt-3 w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition-colors disabled:bg-green-300"
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify Code"}
            </button>
          </form>
        )}
      </div>
      {error && (
        <div className="mt-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
          {typeof error === "string"
            ? error
            : "An error occurred. Please try again."}
        </div>
      )}
    </div>
  );
};

export default CustomerLogin;